import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'app-plan-type',
  templateUrl: './plan-type.component.html',
  styleUrls: ['./plan-type.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class PlanTypeComponent implements OnInit{
  @Input('multiple') isMultiSelect: boolean = false;

  form: FormGroup;
  constructor(private ctrlContainer: FormGroupDirective){};

  ngOnInit(): void {
    this.form = this.ctrlContainer.form;

    this.form.addControl('plan_type', new FormControl());
  }

  selectAll() {
    this.form.controls['plan_type'].setValue(['floater', 'individual']);
  }

  unSelectAll() {
    this.form.controls['plan_type'].setValue([]);
  }

  ngOnDestroy(): void {
    this.form.removeControl('plan_type');
  }
}
